import { Plugin } from 'vue'
import DdErrorHandler from './dd-error-handler'
import router from '@/services/router/router'

declare module 'vue' {
  interface ComponentCustomProperties {
    $error: DdErrorHandler
  }
}

export default {
  install(app) {
    app.config.globalProperties.$error = new DdErrorHandler(router)
  },
} as Plugin
